import * as angular from 'angular';
import LoaderServiceName, {LoaderService} from "./loader.service";

/**
 * @file controller for loader directive
 */
export default angular.module('aps.controller.loader', [LoaderServiceName])
  .controller('LoaderCtrl', LoaderCtrl)
  .name;

/**
 * @class LoaderCtrl
 * @constructor
 * @param {object} loaderService
 */
function LoaderCtrl(loaderService: LoaderService) {
  'use strict';
  var vm = this;
  vm.loadingMessage = 'loading...';

  /**
   * @property appLoading
   * @description toggles the loading screen
   */
  Object.defineProperty(vm,
    'appLoading', {
      get: function() {
        return loaderService.appLoading();
      }
    });
}



// WEBPACK FOOTER //
// ./src/app/components/loader/loader.controller.ts